module.exports = __webpack_public_path__ + "img/submit-active.97fefeed.svg";